import { type FC, useEffect } from "react";
import {
  useSupportRequestsDashboardQuery,
  useSupportRequestsOpenCount,
} from "@/partner/entities/assistant";
import { latestRequests } from "../model/latestRequests";
import { SupportRequestsDashboardCard } from "./SupportRequestsDashboardCard";

const LATEST_LIMIT = 3;

/**
 * Данные карточки обращений на дашборде. Страница рендерит её только тем,
 * кто может читать SupportRequest. Счётчик общий с меню (тот же запрос и
 * кеш, опрос раз в минуту только в Layout); список последних освежается, когда счётчик
 * меняется. Пока ответов нет, карточки нет: ноль до загрузки не значит
 * «обращений нет».
 */
export const SupportRequestsDashboard: FC = () => {
  // Опрашивает Layout (счётчик меню), карточка читает тот же кеш.
  const openRequests = useSupportRequestsOpenCount({ poll: false });
  const { data, refetch } = useSupportRequestsDashboardQuery({
    variables: { rowsPerPage: LATEST_LIMIT },
    fetchPolicy: "cache-and-network",
  });

  useEffect(() => {
    if (openRequests.loaded) void refetch();
    // Только смена счётчика; первый запрос уходит сам.
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [openRequests.count]);

  if (!openRequests.loaded || !data) return null;

  return (
    <SupportRequestsDashboardCard
      activeCount={openRequests.count}
      waitingViewerCount={data.waitingViewer.count}
      latest={latestRequests(
        data.needsReply.nodes,
        data.waitingViewer.nodes,
        LATEST_LIMIT
      )}
    />
  );
};
